export const useWorkAtView = () => {
  const route = useRoute();

  const slugs = ["werken-bij"];

  const workAtView = computed(() =>
    slugs.some((page) => route.path.includes(page)),
  );
  return { workAtView };
};
